import { useEffect, useState } from "react";

export default function LoadingScreen({ delay = 0 }: { delay?: number }) {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!showLoader) {
    return null;
  }

  return (
    <div className="flex fixed inset-0 justify-center items-center">
      <div className="flex flex-col gap-4 items-center">
        <div className="w-12 h-12 rounded-full border-4 border-blue-500 animate-spin border-t-transparent"></div>
      </div>
    </div>
  );
}
